import React, { useState } from 'react';
import { UsersIcon } from 'lucide-react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { Avatar } from '../Avatar';
export function OfferSheet() {
  const {
    offerId,
    openOffer
  } = useUi();
  const {
    templateById,
    activeMembers,
    viewer,
    offer
  } = useAppState();
  const [to, setTo] = useState<string>('vsi');
  const template = templateById(offerId ?? undefined);
  const close = () => {
    openOffer(null);
    setTo('vsi');
  };
  const option = (id: string, label: string, icon: React.ReactNode) => <li key={id} data-id="element-991" data-mp="6o7uiqv7aym1">
      <button type="button" onClick={() => setTo(id)} aria-pressed={to === id} className={`flex w-full items-center gap-3 rounded-2xl border-[1.5px] px-3 py-2.5 text-left font-bold transition-colors duration-150 ${to === id ? 'border-info bg-info-soft text-info-ink' : 'border-line hover:bg-canvas'}`} data-id="element-992" data-mp="6nonw6b03wnb">
        {icon}
        {label}
      </button>
    </li>;
  return <Sheet open={Boolean(template)} onClose={close} title={`Ponudi: ${template?.title ?? ''}`} subtitle="Samo za ta termin – ne za prihodnje ponovitve" footer={<Button className="w-full" onClick={() => {
    if (template) offer(template.id, to);
    close();
  }} data-id="element-994" data-mp="3tve6dhnw1yuw">
          Ponudi
        </Button>} data-id="element-993" data-mp="3kupqehexpofd">
      <ul className="space-y-2" data-id="element-995" data-mp="3261905fnu18c">
        {option('vsi', 'Vsem (skupna oglasna deska)', <span className="grid h-7 w-7 place-items-center rounded-full bg-sun text-ink" data-id="element-996" data-mp="365tneyrqj1lm">
            <UsersIcon className="h-4 w-4" aria-hidden="true" data-id="element-997" data-mp="3azea3unvo95i" />
          </span>)}
        {activeMembers.filter(m => m.id !== viewer.id).map(m => option(m.id, m.name, <Avatar member={m} size="sm" data-id="element-998" data-mp="2igqxz4qv04gk" />))}
      </ul>
      <p className="mt-4 rounded-2xl bg-canvas p-3 text-xs text-muted" data-id="element-999" data-mp="2if60b69905eh">
        Dokler nihče ne sprejme, ostane naloga tvoja odgovornost. Točke dobi dejanski izvajalec po izvedbi in potrebni potrditvi. Pri
        običajni predaji tvoj osnovni cilj ostane enak.
      </p>
    </Sheet>;
}